import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

/**
 * Loading
 * --------
 * Two render modes, picked by call-site:
 *
 *   <Loading />                         → page-level: a centered, dual-ring
 *                                          gradient spinner that fills the
 *                                          available vertical space (60vh
 *                                          min-height) so it sits visually
 *                                          centered inside the page wrapper.
 *
 *   <Loading inline />                  → inline: a single small icon for use
 *                                          next to text inside a button.
 *
 *   <Loading style={{ fontSize: 20 }}/> → backwards-compat: any caller that
 *                                          passed a `style` was using the old
 *                                          inline antd icon; we keep that
 *                                          behavior so existing buttons
 *                                          continue to render correctly.
 *
 * The page-level styles live in src/styles/theme.css under the
 * `Loader / spinner` section.
 */
export const Loading = ({ inline, style, label, fullPage }) => {
  // Inline mode: small antd icon, callers control size via style.
  if (inline || style) {
    return <LoadingOutlined className='global-loading' style={style} />;
  }

  // Page-level mode: centered dual-ring spinner.
  return (
    <div className={`nu-loader ${fullPage ? 'nu-loader-full' : ''}`}>
      <div className='nu-loader-rings' aria-hidden='true'>
        <div className='nu-loader-ring nu-loader-ring-back' />
        <div className='nu-loader-ring nu-loader-ring-front' />
      </div>
      {label ? <div className='nu-loader-label'>{label}</div> : null}
    </div>
  );
};
